import leagueIconWhite from "@/assets/images/icons/games_white/league.svg"
import tftIconWhite from "@/assets/images/icons/games_white/tft.svg"
import fortniteIconWhite from "@/assets/images/icons/games_white/fortnite.svg"
import overwatchIconWhite from "@/assets/images/icons/games_white/ow.svg"
import csgoIconWhite from "@/assets/images/icons/games_white/csgo.svg"
import ssbuIconWhite from "@/assets/images/icons/games_white/ssbu.svg"
import hearthstoneIconWhite from "@/assets/images/icons/games_white/hs.svg"
import magicIconWhite from "@/assets/images/icons/games_white/magic.svg"
import valorantIconWhite from "@/assets/images/icons/games_white/valorant.svg"

import leagueHomeImg from "@/assets/images/home/game/game_icons/league of legends.png"
import fortniteHomeImg from "@/assets/images/home/game/game_icons/fortnite.png"
import ssbuHomeImg from "@/assets/images/home/game/game_icons/smash.png"
import csgoHomeImg from "@/assets/images/home/game/game_icons/csgo.png"
import tftHomeImg from "@/assets/images/home/game/game_icons/tft.png"
import valorantHomeImg from "@/assets/images/home/game/game_icons/valorant.png"

import challengerCoachingIcon from "@/assets/images/home/coach/challenger.png"
import immortal2CoachingIcon from "@/assets/images/home/coach/immortal2.png"
import rank10CoachingIcon from "@/assets/images/home/coach/rank10.png"
import krazyness from "@/assets/images/home/coach/krazyness.png"
import randizzy from "@/assets/images/home/coach/randizzy.png"
import mikolas from "@/assets/images/home/coach/mikolas.png"
import mawashi from "@/assets/images/home/coach/mawashi.png"
import liakopoulos from "@/assets/images/home/coach/liakopoulos.png"
import usae from "@/assets/images/home/coach/usae.png"

import rocketLeagueSubscription from "@/assets/images/games/rocket-league/rocket_league-portrait.png"

import leagueIconGrey from "@/assets/images/icons/games/games_grey/league.svg"
import fortniteIconGrey from "@/assets/images/icons/games/games_grey/fortnite.svg"
import valorantIconGrey from "@/assets/images/icons/games/games_grey/valorant.svg"
import apexIconGrey from "@/assets/images/icons/games/games_grey/apex.svg"
import codcwIconGrey from "@/assets/images/icons/games/games_grey/codcw.svg"
import csgoIconGrey from "@/assets/images/icons/games/games_grey/csgo.svg"
import ssbuIconGrey from "@/assets/images/icons/games/games_grey/ssbu.svg"
import hsIconGrey from "@/assets/images/icons/games/games_grey/hs.svg"
import tftIconGrey from "@/assets/images/icons/games/games_grey/tft.svg"
import magicIconGrey from "@/assets/images/icons/games/games_grey/magic.svg"
import rlIconGrey from "@/assets/images/icons/games/games_grey/rl.svg"

import leagueIconWhiteV2 from "@/assets/images/icons/games/games_white/league.svg"
import fortniteIconWhiteV2 from "@/assets/images/icons/games/games_white/fortnite.svg"
import valorantIconWhiteV2 from "@/assets/images/icons/games/games_white/valorant.svg"
import apexIconWhiteV2 from "@/assets/images/icons/games/games_white/apex.svg"
import codcwIconWhiteV2 from "@/assets/images/icons/games/games_white/codcw.svg"
import csgoIconWhiteV2 from "@/assets/images/icons/games/games_white/csgo.svg"
import ssbuIconWhiteV2 from "@/assets/images/icons/games/games_white/ssbu.svg"
import hsIconWhiteV2 from "@/assets/images/icons/games/games_white/hs.svg"
import tftIconWhiteV2 from "@/assets/images/icons/games/games_white/tft.svg"
import magicIconWhiteV2 from "@/assets/images/icons/games/games_white/magic.svg"
import rlIconWhiteV2 from "@/assets/images/icons/games/games_white/rl.svg"

import leagueIconActive from "@/assets/images/icons/games/games_colorful/league.svg"
import fortniteIconActive from "@/assets/images/icons/games/games_colorful/fortnite.svg"
import valorantIconActive from "@/assets/images/icons/games/games_colorful/valorant.svg"
import apexIconActive from "@/assets/images/icons/games/games_colorful/apex.svg"
import codcwIconActive from "@/assets/images/icons/games/games_colorful/codcw.svg"
import csgoIconActive from "@/assets/images/icons/games/games_colorful/csgo.svg"
import ssbuIconActive from "@/assets/images/icons/games/games_colorful/ssbu.svg"
import hsIconActive from "@/assets/images/icons/games/games_colorful/hs.svg"
import tftIconActive from "@/assets/images/icons/games/games_colorful/tft.svg"
import magicIconActive from "@/assets/images/icons/games/games_colorful/magic.svg"
import rlIconActive from "@/assets/images/icons/games/games_colorful/rl.svg"

export const GAME_KEYS = {
  AIM_LAB: "aimlab",
  APEX_LEGENDS: "apex-legends",
  BRAWLHALLA: "brawlhalla",
  CHESS: "chess",
  CLASH_ROYALE: "clash-royale",
  COD_COLD_WAR: "cod-cold-war",
  COD_MODERN_WARFARE: "cod-modern-warfare",
  COD_WARZONE: "cod-warzone",
  COD_VANGUARD: "cod-vanguard",
  CSGO: "csgo",
  DESTINY2: "destiny2",
  DOTA2: "dota2",
  FIFA: "fifa",
  FORTNITE: "fortnite",
  HALO_INFINITE: "halo-infinite",
  HEARTHSTONE: "hearthstone",
  LEAGUE_OF_LEGENDS: "leagueoflegends",
  MTG: "magic-the-gathering",
  OVERWATCH: "overwatch",
  PUBG: "pubg",
  RAINBOW_SIX_SIEGE: "rainbow-six-siege",
  ROCKET_LEAGUE: "rocket-league",
  SMITE: "smite",
  SSBU: "super-smash-bros-ultimate",
  TEAMFIGHT_TACTICS: "teamfight-tactics",
  VALORANT: "valorant",
  WILD_RIFT: "wild-rift",
  WOW: "world-of-warcraft",
}

export const GAME_ICON_GREY = {
  [GAME_KEYS.APEX_LEGENDS]: apexIconGrey,
  [GAME_KEYS.COD_COLD_WAR]: codcwIconGrey,
  [GAME_KEYS.CSGO]: csgoIconGrey,
  [GAME_KEYS.FORTNITE]: fortniteIconGrey,
  [GAME_KEYS.HEARTHSTONE]: hsIconGrey,
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: leagueIconGrey,
  [GAME_KEYS.MTG]: magicIconGrey,
  [GAME_KEYS.ROCKET_LEAGUE]: rlIconGrey,
  [GAME_KEYS.SSBU]: ssbuIconGrey,
  [GAME_KEYS.TEAMFIGHT_TACTICS]: tftIconGrey,
  [GAME_KEYS.VALORANT]: valorantIconGrey,
}

export const GAME_ICON_WHITE = {
  [GAME_KEYS.APEX_LEGENDS]: apexIconWhiteV2,
  [GAME_KEYS.COD_COLD_WAR]: codcwIconWhiteV2,
  [GAME_KEYS.CSGO]: csgoIconWhiteV2,
  [GAME_KEYS.FORTNITE]: fortniteIconWhiteV2,
  [GAME_KEYS.HEARTHSTONE]: hsIconWhiteV2,
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: leagueIconWhiteV2,
  [GAME_KEYS.MTG]: magicIconWhiteV2,
  [GAME_KEYS.ROCKET_LEAGUE]: rlIconWhiteV2,
  [GAME_KEYS.SSBU]: ssbuIconWhiteV2,
  [GAME_KEYS.TEAMFIGHT_TACTICS]: tftIconWhiteV2,
  [GAME_KEYS.VALORANT]: valorantIconWhiteV2,
}

export const GAME_ICON_ACTIVE = {
  [GAME_KEYS.APEX_LEGENDS]: apexIconActive,
  [GAME_KEYS.COD_COLD_WAR]: codcwIconActive,
  [GAME_KEYS.CSGO]: csgoIconActive,
  [GAME_KEYS.FORTNITE]: fortniteIconActive,
  [GAME_KEYS.HEARTHSTONE]: hsIconActive,
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: leagueIconActive,
  [GAME_KEYS.MTG]: magicIconActive,
  [GAME_KEYS.ROCKET_LEAGUE]: rlIconActive,
  [GAME_KEYS.SSBU]: ssbuIconActive,
  [GAME_KEYS.TEAMFIGHT_TACTICS]: tftIconActive,
  [GAME_KEYS.VALORANT]: valorantIconActive,
}

export const HOME_GAME_NAME = {
  [GAME_KEYS.APEX_LEGENDS]: "Apex Legends",
  [GAME_KEYS.BRAWLHALLA]: "Brawlhalla",
  [GAME_KEYS.CHESS]: "Chess",
  [GAME_KEYS.COD_COLD_WAR]: "COD: Cold War",
  [GAME_KEYS.COD_MODERN_WARFARE]: "COD: Modern Warfare",
  [GAME_KEYS.COD_WARZONE]: "COD: Warzone",
  [GAME_KEYS.CSGO]: "Counter Strike",
  [GAME_KEYS.DESTINY2]: "Destiny 2",
  [GAME_KEYS.DOTA2]: "Dota 2",
  [GAME_KEYS.FIFA]: "FIFA 21",
  [GAME_KEYS.FORTNITE]: "Fortnite",
  [GAME_KEYS.HALO_INFINITE]: "Halo Infinite",
  [GAME_KEYS.HEARTHSTONE]: "Hearthstone",
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: "League of legends",
  [GAME_KEYS.MTG]: "Magic: The Gathering",
  [GAME_KEYS.OVERWATCH]: "Overwatch",
  [GAME_KEYS.PUBG]: "PlayerUnknown's Battlegrounds",
  [GAME_KEYS.RAINBOW_SIX_SIEGE]: "Rainbow Six Siege",
  [GAME_KEYS.ROCKET_LEAGUE]: "Rocket League",
  [GAME_KEYS.SMITE]: "SMITE",
  [GAME_KEYS.SSBU]: "Super Smash Bros",
  [GAME_KEYS.TEAMFIGHT_TACTICS]: "Teamfight Tactics",
  [GAME_KEYS.VALORANT]: "VALORANT",
  [GAME_KEYS.WILD_RIFT]: "League of Legends: Wild Rift",
  [GAME_KEYS.WOW]: "World of Warcraft",
}

const leagueRecordHints = [
  "1. Open your Replays folder, replays are stored in \"C:\\Users\\[user]\\Documents\\League of Legends\\Replays\".",
  "2. The easiest way to share a particular replay is to delete any .rofl files that are in the folder. Once that's done, you can download the replay you want to share via the button in your match history.",
  "3. Once the download is complete you will then have a new file in the replays folder.",
  "4. Upload the new file here to get your Pro Video Review.",
  "Note: Do not upload a .rofl file from an outdated patch. Pros can only view replays from the current patch.",
]

const fortniteRecordHints = [
  "1. Launch Fortnite then open your Fortnite Career.",
  "2. Select \"Replays\".",
  "3. Choose and select the replay you want to share.",
  "4. Click on \"Rename and Save\" then rename the replay to \"proguides\".",
  "5. Click on \"Open Replay Folder\".",
  "6. Fortnite will then open a folder and you will be able to upload the file named \"proguides.replay\" here.",
]

const overwatchRecordHints = [
  "1. Launch Overwatch",
  "2. Go into \"Career Profile\"",
  "3. Head into the \"Replay\" Section",
  "4. Select the match you want reviewed.",
  "5. Click the share button, then copy and paste the code here.",
]

const dota2RecordHints = [
  "1. Launch DOTA 2.",
  "2. Go to your \"Profile\" and click on \"Recent Matches\".",
  "3. Click on a match to see an Overview.",
  "4. Find the Match ID at the bottom of the interface.",
  "5. Copy and paste the Match ID here.",
]

const generalRecordHints = [
  "To record your gameplay, use a screen recording software like Windows Screen Recorder or OBS to capture your video file.",
]

export const GAME_RECORD_HINTS = {
  [GAME_KEYS.CSGO]: generalRecordHints,
  [GAME_KEYS.DOTA2]: dota2RecordHints,
  [GAME_KEYS.FORTNITE]: fortniteRecordHints,
  [GAME_KEYS.HEARTHSTONE]: generalRecordHints,
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: leagueRecordHints,
  [GAME_KEYS.MTG]: generalRecordHints,
  [GAME_KEYS.OVERWATCH]: overwatchRecordHints,
  [GAME_KEYS.SSBU]: generalRecordHints,
  [GAME_KEYS.TEAMFIGHT_TACTICS]: generalRecordHints,
  [GAME_KEYS.VALORANT]: generalRecordHints,
  [GAME_KEYS.WOW]: generalRecordHints,
}

export const GAME_RECORD_HINTS_TITLE = {
  [GAME_KEYS.CSGO]: "How to record your gameplay on the computer",
  [GAME_KEYS.DOTA2]: "How to find your replay on the computer",
  [GAME_KEYS.FORTNITE]: "How to find your replay on the computer",
  [GAME_KEYS.HEARTHSTONE]: "How to record your gameplay on the computer",
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: "How to find your replay on the computer",
  [GAME_KEYS.MTG]: "How to record your gameplay on the computer",
  [GAME_KEYS.OVERWATCH]: "How to find your replay on the computer",
  [GAME_KEYS.SSBU]: "How to record your gameplay on the computer",
  [GAME_KEYS.TEAMFIGHT_TACTICS]: "How to record your gameplay on the computer",
  [GAME_KEYS.VALORANT]: "How to record your gameplay on the computer",
  [GAME_KEYS.WOW]: "How to record your gameplay on the computer",
}

export const SUPPORTED_VOD_EXTENSION = {
  [GAME_KEYS.FORTNITE]: "replay",
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: "rofl",
}

export const IN_GAME_NAME_LABEL = {
  [GAME_KEYS.CSGO]: "Player Username",
  [GAME_KEYS.DOTA2]: "Player Username",
  [GAME_KEYS.FORTNITE]: "EPIC NAME",
  [GAME_KEYS.HEARTHSTONE]: "BattleTag",
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: "Summoner Name",
  [GAME_KEYS.MTG]: "Player Username",
  [GAME_KEYS.OVERWATCH]: "BattleTag",
  [GAME_KEYS.SSBU]: "Player Name",
  [GAME_KEYS.TEAMFIGHT_TACTICS]: "Summoner Name",
  [GAME_KEYS.VALORANT]: "Player Username",
  [GAME_KEYS.WOW]: "BattleTag",
}

export const GAME_CODE_LABEL = {
  [GAME_KEYS.DOTA2]: "Match ID",
  [GAME_KEYS.OVERWATCH]: "Replay Code",
  [GAME_KEYS.AIM_LAB]: "Replay Link",
}

const howToOpenRofl = [
  "Go into your \"Riot Games\" folder then click \"game\". (C:\\Riot Games\\League of Legends\\Game)",
  "Right click on \"League of Legends.exe\" and create a shortcut.",
  "Move the shortcut to your desktop.",
  "Download the student replay file then move it to your desktop.",
  "Drag the replay file over the League of Legends shortcut. The replay will then begin.",
]

const howToOpenReplay = [
  "Launch Fortnite then open your Fortnite Career.",
  "Select \"Replays\".",
  "Click on \"Open Replay Folder\".",
  "Download, then copy the student replay and paste it into your replay folder.",
  "Go back to Fortnite and click \"refresh\".",
  "Select the Student Replay then click on \"Play\".",
]

const howToOpenOverWatchReplay = [
  "Launch Overwatch.",
  "Go into \"Career Profile\".",
  "Head into the \"Replay\" Section.",
  "Click on \"Import\" and enter the replay code.",
  "Selected the imported match and click \"View Replay\"",
]

const howToOpenDota2Replay = [
  "Launch Dota 2.",
  "Go to the \"Watch\" section and select \"Replays\".",
  "Enter the Match ID into the search bar to see the match overview.",
  "Click on \"Watch Replay\".",
]

export const HOW_TO_OPEN_FILE = {
  ".ROFL": howToOpenRofl,
  ".REPLAY": howToOpenReplay,
  "overwatch": howToOpenOverWatchReplay,
  "dota2": howToOpenDota2Replay,
}

export const SUBSCRIPTIONS_GAMES = [
  {
    key: GAME_KEYS.LEAGUE_OF_LEGENDS,
    name: "League of Legends",
    icon:
      "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL3dlYi1hc3NldHMvbWFya2V0aW5nL2NoZWNrb3V0L2dhbWUtcG9ydHJhaXRzL2xlYWd1ZW9mbGVnZW5kcy5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEzMCwiaGVpZ2h0IjoxNzUsImZpdCI6ImNvdmVyIiwiYmFja2dyb3VuZCI6eyJyIjowLCJnIjowLCJiIjowLCJhbHBoYSI6MX19LCJmbGF0dGVuIjp0cnVlfX0=",
    status: "available",
  },
  {
    key: GAME_KEYS.VALORANT,
    name: "Valorant",
    icon:
      "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL3dlYi1hc3NldHMvbWFya2V0aW5nL2NoZWNrb3V0L2dhbWUtcG9ydHJhaXRzL3ZhbG9yYW50LnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTMwLCJoZWlnaHQiOjE3NSwiZml0IjoiY292ZXIiLCJiYWNrZ3JvdW5kIjp7InIiOjAsImciOjAsImIiOjAsImFscGhhIjoxfX0sImZsYXR0ZW4iOnRydWV9fQ==",
    status: "available",
  },
  {
    key: GAME_KEYS.APEX_LEGENDS,
    name: "Apex Legends",
    icon:
      "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL3dlYi1hc3NldHMvbWFya2V0aW5nL2NoZWNrb3V0L2dhbWUtcG9ydHJhaXRzL2FwZXgtbGVnZW5kcy5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEzMCwiaGVpZ2h0IjoxNzUsImZpdCI6ImNvdmVyIn19fQ==",
    status: "available",
  },
  {
    key: GAME_KEYS.HALO_INFINITE,
    name: "Halo Infinite",
    icon:
      "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL3dlYi1hc3NldHMvbWFya2V0aW5nL2NoZWNrb3V0L2dhbWUtcG9ydHJhaXRzL2hhbG8taW5maW5pdGUuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxMzAsImhlaWdodCI6MTc1LCJmaXQiOiJjb3ZlciJ9fX0=",
    status: "available",
  },
  {
    key: GAME_KEYS.RAINBOW_SIX_SIEGE,
    name: "Rainbow 6 Siege",
    icon:
      "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL3dlYi1hc3NldHMvbWFya2V0aW5nL2NoZWNrb3V0L2dhbWUtcG9ydHJhaXRzL3JhaW5ib3ctc2l4LXNpZWdlLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTMwLCJoZWlnaHQiOjE3NSwiZml0IjoiY292ZXIifX19",
    status: "available",
  },
  {
    key: GAME_KEYS.FORTNITE,
    name: "Fortnite",
    icon:
      "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL3dlYi1hc3NldHMvbWFya2V0aW5nL2NoZWNrb3V0L2dhbWUtcG9ydHJhaXRzL2ZvcnRuaXRlLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTMwLCJoZWlnaHQiOjE3NSwiZml0IjoiY292ZXIiLCJiYWNrZ3JvdW5kIjp7InIiOjAsImciOjAsImIiOjAsImFscGhhIjoxfX0sImZsYXR0ZW4iOnRydWV9fQ==",
    status: "available",
  },
  {
    key: GAME_KEYS.ROCKET_LEAGUE,
    name: "Rocket League",
    icon: rocketLeagueSubscription,
    status: "available",
  },
  {
    key: GAME_KEYS.CSGO,
    name: "Counter Strike: Global Offensive",
    icon:
      "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL3dlYi1hc3NldHMvbWFya2V0aW5nL2NoZWNrb3V0L2dhbWUtcG9ydHJhaXRzL2NzZ28ucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxMzAsImhlaWdodCI6MTc1LCJmaXQiOiJjb3ZlciIsImJhY2tncm91bmQiOnsiciI6MCwiZyI6MCwiYiI6MCwiYWxwaGEiOjF9fSwiZmxhdHRlbiI6dHJ1ZX19",
    status: "available",
  },
]

export const ACTIVE_GAMES_NAMES = {
  "League of Legends": "leagueoflegends",
  "Fortnite": "fortnite",
  "VALORANT": "valorant",
  "Super Smash Bros. Ultimate": "super-smash-bros-ultimate",
  "Overwatch": "overwatch",
  "Hearthstone": "hearthstone",
  "Counter Strike: Global Offensive": "csgo",
  "World of Warcraft": "world-of-warcraft",
  "Magic: The Gathering - Arena": "magic-the-gathering",
  "Dota 2": "dota2",
  "Teamfight Tactics": "teamfight-tactics",
  "Apex Legends": "apex-legends",
  "COD: Cold War": "cod-cold-war",
  "Rocket League": "rocket-league",
  "Brawlhalla": "brawlhalla",
}

export const ONBOARDING_GAME_NAMES = {
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: "League of Legends",
  [GAME_KEYS.TEAMFIGHT_TACTICS]: "Teamfight Tactics",
  [GAME_KEYS.FORTNITE]: "Fortnite",
  [GAME_KEYS.OVERWATCH]: "Overwatch",
  [GAME_KEYS.CSGO]: "Counter Strike: Global Offensive",
  [GAME_KEYS.DOTA2]: "Dota 2",
  [GAME_KEYS.SSBU]: "Super Smash Bros. Ultimate",
  [GAME_KEYS.WOW]: "World of Warcraft",
  [GAME_KEYS.HEARTHSTONE]: "Hearthstone",
  [GAME_KEYS.MTG]: "Magic: The Gathering - Arena",
  [GAME_KEYS.VALORANT]: "VALORANT",
  [GAME_KEYS.COD_COLD_WAR]: "COD: Cold War",
  [GAME_KEYS.ROCKET_LEAGUE]: "Rocket League",
  [GAME_KEYS.BRAWLHALLA]: "Brawlhalla",
}

export const DASHBOARD_GAME_QUESTION_SETS = {
  "League of Legends": 2,
  "Teamfight Tactics": 1,
  "Fortnite": 1,
  "Overwatch": 1,
  "Counter Strike: Global Offensive": 1,
  "Dota 2": 1,
  "Super Smash Bros. Ultimate": 1,
  "World of Warcraft": 1,
  "Hearthstone": 1,
  "Magic: The Gathering - Arena": 1,
  "VALORANT": 1,
}

export const GAME_ICONS_WHITE = {
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: leagueIconWhite,
  [GAME_KEYS.TEAMFIGHT_TACTICS]: tftIconWhite,
  [GAME_KEYS.FORTNITE]: fortniteIconWhite,
  [GAME_KEYS.OVERWATCH]: overwatchIconWhite,
  [GAME_KEYS.CSGO]: csgoIconWhite,
  [GAME_KEYS.SSBU]: ssbuIconWhite,
  [GAME_KEYS.HEARTHSTONE]: hearthstoneIconWhite,
  [GAME_KEYS.MTG]: magicIconWhite,
  [GAME_KEYS.VALORANT]: valorantIconWhite,
}
const LEAGUE_OF_LEGENDS_CONVERSATION = {
  name: "Krazyness",
  avatar: krazyness,
  achievement: "Challenger",
  achievementIcon: challengerCoachingIcon,
  regions: ["NA", "EUW", "EUNE", "OCE", "LAN"],
  avgRating: 5,
  totalRating: 1625,
  gameIcon: leagueHomeImg,
}

const FORTNITE_CONVERSATION = {
  name: "randizzy",
  avatar: randizzy,
  achievement: "7.0+ K/D",
  regions: ["NAE", "NAW", "EU", "OCE", "ME"],
  avgRating: 5,
  totalRating: 378,
  gameIcon: fortniteHomeImg,
}

const VALORANT_CONVERSATION = {
  name: "Mikolas",
  avatar: mikolas,
  achievement: "Immortal 2",
  achievementIcon: immortal2CoachingIcon,
  regions: [],
  avgRating: 5,
  totalRating: 128,
  gameIcon: valorantHomeImg,
}

const CSGO_CONVERSATION = {
  name: "Mawashi",
  avatar: mawashi,
  achievement: "FACEIT Rank 10",
  achievementIcon: rank10CoachingIcon,
  regions: ["NA", "EU", "OCE", "BR", "KR"],
  avgRating: 5,
  totalRating: 151,
  gameIcon: csgoHomeImg,
}

const TFT_CONVERSATION = {
  name: "Liakopoulos",
  avatar: liakopoulos,
  achievement: "Challenger",
  regions: ["NA", "EUW", "EUNE", "OCE", "LAN"],
  avgRating: 5,
  totalRating: 337,
  gameIcon: tftHomeImg,
}

const SSBU_CONVERSATION = {
  name: "USAE I Indestruct1ble",
  avatar: usae,
  achievement: "State Ranked Player",
  regions: ["NA", "EU", "OCE", "JP", "BR"],
  avgRating: 5,
  totalRating: 506,
  gameIcon: ssbuHomeImg,
}

export const COACHING_CONVERSATIONS = [
  LEAGUE_OF_LEGENDS_CONVERSATION,
  FORTNITE_CONVERSATION,
  VALORANT_CONVERSATION,
  CSGO_CONVERSATION,
  TFT_CONVERSATION,
  SSBU_CONVERSATION,
]



// WEBPACK FOOTER //
// ./src/store/game/game.constants.js